import React, { useState, useEffect } from 'react'
import { httpService } from '../services/http.service'

const BLANK_JOB_TEMPLATE = {
    title: '',
    img: '',
    description: '',
    requirements: [],
    responsibilities: [],
    additional: '',
    assignment: '',
}

export function JobForm({ jobToEdit, onSave, onClose }) {
    const [formData, setFormData] = useState(BLANK_JOB_TEMPLATE)
    const [imageFile, setImageFile] = useState(null)
    const [imagePreview, setImagePreview] = useState('')
    const [isSaving, setIsSaving] = useState(false)

    const isEditing = !!jobToEdit

    useEffect(() => {
        if (isEditing) {
            setFormData({
                ...jobToEdit,
                requirements: jobToEdit.requirements.join('\n'),
                responsibilities: jobToEdit.responsibilities.join('\n'),
            })
            setImagePreview(jobToEdit.img)
        } 
        else {
            setFormData(BLANK_JOB_TEMPLATE)
            setImagePreview('')
        }
        setImageFile(null)
    }, [jobToEdit, isEditing])

    // Cleanup object URL to prevent memory leaks
    useEffect(() => {
        return () => {
            if (imagePreview && imagePreview.startsWith('blob:')) {
                URL.revokeObjectURL(imagePreview)
            }
        }
    }, [imagePreview])


    const handleChange = (e) => {
        const { name, value } = e.target
        setFormData(prev => ({ ...prev, [name]: value }))
    }

    const handleImageChange = (e) => {
        const file = e.target.files[0]
        if (file) {
            setImageFile(file)
            const localImageUrl = URL.createObjectURL(file)
            setImagePreview(localImageUrl)
        }
    }

    const handleSubmit = async (e) => {
        e.preventDefault()
        setIsSaving(true)
        let finalImageUrl = formData.img

        if (imageFile) {
            try {
                const image = await httpService.uploadImage(imageFile)
                finalImageUrl = image
            }
            catch (error) {
                alert("שגיאה בהעלאת התמונה!")
                setIsSaving(false)
                return
            }
        }

        const finalJobData = {
            ...formData,
            img: finalImageUrl,
            requirements: formData.requirements.toString().split('\n').filter(line => line.trim() !== ''),
            responsibilities: formData.responsibilities.toString().split('\n').filter(line => line.trim() !== ''),
        }

        onSave(finalJobData)
        setIsSaving(false)
    }

    return (
        <div className="form-modal-overlay">
            <div className="form-modal-content">
                <span onClick={onClose} className="material-symbols-outlined close-button">close</span>
                <h2>{isEditing ? 'עריכת משרה' : 'הוספת משרה חדשה'}</h2>
                <form onSubmit={handleSubmit}>
                    <label>כותרת המשרה</label>
                    <input name="title" value={formData.title} onChange={handleChange} required />

                    <label>תיאור המשרה</label>
                    <textarea name="description" value={formData.description} onChange={handleChange} required rows="4" />

                    <label>דרישות (כל דרישה בשורה חדשה)</label>
                    <textarea name="requirements" value={formData.requirements} onChange={handleChange} required rows="5" />

                    <label>תחומי אחריות (כל אחריות בשורה חדשה)</label>
                    <textarea name="responsibilities" value={formData.responsibilities} onChange={handleChange} required rows="4" />

                    <label>מידע נוסף (אופציונלי)</label>
                    <input name="additional" value={formData.additional} onChange={handleChange} />

                    <label>קישור למשימה (אופציונלי)</label>
                    <input name="assignment" type="url" value={formData.assignment} onChange={handleChange} />

                    <label>תמונת משרה</label>
                    <input type="file" accept="image/*" onChange={handleImageChange} />
                    {imagePreview && (
                        <div className="image-preview-container">
                            <img src={imagePreview} alt="תצוגה מקדימה" className="image-preview" />
                        </div>
                    )}

                    <div className="form-actions">
                        <button type="submit" disabled={isSaving}>
                            {isSaving ? 'שומר...' : 'שמור משרה'}
                        </button>
                        <button type="button" onClick={onClose} disabled={isSaving}>ביטול</button>
                    </div>
                </form>
            </div>
        </div>
    )
}